import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { tPaymentModel } from '../models/tPaymentModel';



@Injectable({
    providedIn: 'root'
})

export class tPaymentService {

    /*
    private selected_pack_itemID_Source = new BehaviorSubject('');
    current_selected_pack_itemID = this.selected_pack_itemID_Source.asObservable();

    private selected_pack_itemName_Source = new BehaviorSubject('');
    current_selected_pack_itemName = this.selected_pack_itemName_Source.asObservable();

    private selected_pack_itemUnit_Source = new BehaviorSubject('');
    current_selected_pack_itemUnit = this.selected_pack_itemUnit_Source.asObservable();

    private selected_pack_standardPrice_Source = new BehaviorSubject(0);
    current_selected_pack_standardPrice = this.selected_pack_standardPrice_Source.asObservable();

    shareSelected(selecteditemID: string, selecteditemName: string, selecteditemUnit: string, selectedStandardPrice: number) {
      this.selected_pack_itemID_Source.next(selecteditemID);
      this.selected_pack_itemName_Source.next(selecteditemName);
      this.selected_pack_itemUnit_Source.next(selecteditemUnit);

      this.selected_pack_standardPrice_Source.next(selectedStandardPrice);
    }
    */

    
    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tPaymentModels';

    getAllData() {
        return this.http.get<tPaymentModel[]>(this.baseurl + this.pathName);
    }

    // getAllDataWithItemInfo() {
    //     return this.http.get<tPaymentModel[]>(this.baseurl + this.pathName + '/WithItemInfo');
    // }

    getDataById(shopID: string, paymentID: string) {
        return this.http.get<tPaymentModel>(this.baseurl + this.pathName + '/' + shopID + '/' + paymentID);
    }

    addData(data: tPaymentModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted', data);
    }

    // addMultiData(data: tPaymentModel) {
    //     return this.http.post(this.baseurl + this.pathName + '/Formatted/Multi', data);
    // }

    deleteData(data: tPaymentModel) {
        return this.http.delete(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.paymentID);
    }

    updateData(data: tPaymentModel) {
        return this.http.put(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.paymentID, data);
    }


    getActiveData(shopID: string) {
        return this.http.get<tPaymentModel[]>(this.baseurl + this.pathName + '/ActiveMethod/'+ shopID);
    }

    getPaymentIsIsed(paymentMethodID:string){
        return this.http.get<boolean>(this.baseurl + this.pathName + '/GetPaymentMethodIsUsed/'+ paymentMethodID);
    }

}